/**
 * Rank codes that are placeholders rather than earned ranks, and must never be
 * painted on a genealogy node box.
 *
 * `DISTRIBUTOR` is written onto ~every legacy-imported slot by the import engine
 * (`membershipCodeFromLegacy` uppercases it) but exists in NO comp-plan rank
 * config — the seeded stairstep ranks are bronze/silver/gold. Compared
 * case-insensitively because the import uppercases while plan configs are lowercase.
 */
const HIDDEN_RANK_CODES = new Set(['distributor']);

/**
 * The rank to paint on a node box, or `null` when there is nothing meaningful
 * (absent, blank, or a placeholder). Callers render NOTHING on `null` — the same
 * way the admin slots list ("—") and the member standing panel ("Unranked") already
 * degrade. The node box is the only surface that ever invented a label.
 */
export function displayRankCode(rankCode: string | null | undefined): string | null {
  const trimmed = rankCode?.trim();
  if (!trimmed) return null;
  return HIDDEN_RANK_CODES.has(trimmed.toLowerCase()) ? null : trimmed;
}
